<template>
  <div class="enable-payment-settings-container">
    <div class="intro-text">
      To start accepting payments, Just complete a few steps 👇
    </div>

    <div class="step-card">
      <div class="step-card-inner">
        <div class="step-title" @click="openPaymentsGatewayPage">
          <span class="step-title-text">Enable payment methods</span>
          <LinkIcon />
        </div>
        <div class="step-description">
          Choose the payment methods that best suit your customers.
        </div>
      </div>
    </div>

    <div class="step-card">
      <div class="step-card-inner">
        <div class="step-title" @click="openSmartRoutingPage">
          <span class="step-title-text">Set Chargebee Pay as default</span>
          <LinkIcon />
        </div>
        <div class="step-description">
          Set up Chargebee Pay as the default option for your selected payment methods.
        </div>
      </div>
    </div>

    <div class="mark-done-button-wrapper">
      <s-button @click="markAsDone" variant="neutral" size="large" style-type="outline">
        <span class="mark-done-button-text">Mark As Done</span>
        <s-icon name="check" size="16" />
      </s-button>
    </div>
  </div>
</template>


<script>
import LinkIcon from "@/components/icons/LinkIcon.vue";
import {
  getCbAppUrl,
  openUrlInNewTab
} from "@/app/utils/common/functions/url-helper";
import { mapGetters } from "vuex";

export default {
  name: "EnablePaymentSettings",
  components: { LinkIcon },
  computed: {
    ...mapGetters('app', ['getCbSiteName']),
  },
  methods: {
    openSmartRoutingPage() {
      openUrlInNewTab(getCbAppUrl(this.getCbSiteName) + "/payment_gateways/smart_routing")
    },
    openPaymentsGatewayPage() {
      openUrlInNewTab(getCbAppUrl(this.getCbSiteName) + "/payment_gateways")
    },
    markAsDone() {
      this.$emit("handleMarkAsDone")
    }
  }
};
</script>

<style lang="scss">
.enable-payment-settings-container {
  display: flex;
  flex-direction: column;

  .intro-text {
    font-size: 14px;
    display: flex;
  }

  .step-card {
    display: flex;
    flex-direction: column;
    border-style: solid;
    border-color: $border_color;
    border-radius: 6px;
    margin-top: 8px;

    .step-card-inner {
      margin: 12px;

      .step-title {
        color: $primary_400;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        display: flex;

        .step-title-text {
          padding-right: 6px;
        }
      }

      .step-description {
        text-align: left;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  .mark-done-button-wrapper {
    display: flex;
    margin-top: 8px;
    font-size: 14px;

    .c-button {
      display: flex;

      .c-button__label {
        padding: unset !important;
      }

      .mark-done-button-text {
        display: flex;
        padding-right: 4px;
        font-weight: $fw_medium;
        font-size: 14px;
      }

      .button-label {
        display: flex;
        align-items: center;
        font-weight: $fw_medium;
      }
    }
  }
}

</style>